import { create } from 'zustand'

import type { LeadDistributionPreference } from 'src/shared/features/enterprise/api/use-update-enterprise-settings'

import type { EnterpriseBusinessImportPreviewResponse } from '../api/use-enterprise-business-import-preview'

export interface UploadedFileMeta {
  file: File
  name: string
  size: number
  type: string
  previewData: EnterpriseBusinessImportPreviewResponse
}

export interface ULFormData {
  /** Is the uploaded file closed deal leads. */
  closedDeals?: boolean | null
  /** Whether Lynk should be enabled for this imported file. */
  lynkEnabledForFile?: boolean | null
  /** The uploaded file. Use this if closed deals is false. */
  uploadedFile?: UploadedFileMeta | null
  /** Whether the uploaded file has a Closed Date column. */
  uploadedFileHasClosedDate: boolean
  /** Selected lead distribution system ID for the import. */
  distributionSystemId?: number | null
  /** Selected lead distribution preference for the import. */
  leadDistributionPreference?: LeadDistributionPreference | null
}

interface UploadLeadsState {
  formData: ULFormData
  setFormData: (formData: ULFormData) => void
  getFormData: () => ULFormData
  reset: () => void
}

export const useUploadLeadsStore = create<UploadLeadsState>((set, get) => ({
  formData: {
    uploadedFile: null,
    closedDeals: null,
    lynkEnabledForFile: null,
    uploadedFileHasClosedDate: false,
    distributionSystemId: null,
    leadDistributionPreference: null,
  },
  setFormData: (formData) => set({ formData }),
  getFormData: () => get().formData,
  reset: () =>
    set({
      formData: {
        uploadedFile: null,
        closedDeals: null,
        lynkEnabledForFile: null,
        uploadedFileHasClosedDate: false,
        distributionSystemId: null,
        leadDistributionPreference: null,
      },
    }),
}))
